<template>
    <div role="main">
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <!-- Termly Tracking Code -->
                    <div
                        name="termly-embed"
                        data-id="e4db3a5f-943c-4b76-861d-290c9ab5f46b"
                        data-type="iframe" />
                    <div id="termlyScriptContainer" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    data: () => {
        return {
            name: 'PrivacyPolicy'
        };
    },
    metaInfo: {
        title: 'Privacy Policy'
    },
    mounted: function() {
        const tscDiv = document.getElementById('termlyScriptContainer');
        const tscScript = document.createElement('script');
        tscScript.id = 'termlyScript';
        tscScript.type = 'text/javascript';
        tscDiv.appendChild(tscScript);
        const js = document.createElement('script');
        js.id = 'termly-jssdk';
        js.src = 'https://app.termly.io/embed-policy.min.js';
        document.head.appendChild(js);
    }
};
</script>

<style scoped>

</style>
